import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent {
  urlBlobStorage: string= environment.blobstorage;
  backgroundImage: string = `${this.urlBlobStorage}Home/Images/Cuadricula-de-repeticion-1.webp`;

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
